export enum statusList {
    InActive= 0,
    Active= 1,
    Suspended= 2
}
